export const initialText = `# Markdown2PDF 
https://realdennis.github.io/md2pdf/
> Awesome Markdown to PDF!
\`\`\`diff
- Online? Upload resume.md to stranger server?
+ Try Offline Web App!
\`\`\`

## How to use md2pdf?
1. Click button choose \`.md\` file.
2. Edit in editor (left panel).
3. Click **Transform**!
4. Switch 'Destination' to **Save as PDF**.
4. **Chrome recommended**

## Tips
- \`Resize\` the layout what you want.
- After click \`Transform\` button, inverse the checkbox of **'Headers and Footers'**. 
- **反選頁首與頁尾**.

## What's special?
- You can use <span style="color:#0984e3">html</span> tag!
<blockquote>Hey I'm in blockquote!</blockquote>

## Profile
- Github: [@realdennis](https://github.com/realdennis)
- Project: md2pdf (Markdown2PDF)
- What about me: ☕ 、 👨🏻‍💻️、 🍕、 🎞️

## Code Like this
\`\`\`javascript
// index.js
function Hello(){
  console.log('World!')
}
Hello();
\`\`\`

or this

\`\`\`python
# main.py
def awesome():
    print('awesome!')
awesome()
\`\`\`

`;
